// extracted by mini-css-extract-plugin
export default {"noPermissions":"no_permissions-module___noPermissions___e43a50e2"};